import { FC } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { Fire02Icon } from "@hugeicons-pro/core-solid-rounded";
import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import {
  APPROVAL_LIKELIHOOD_BAND_LABEL,
  type ApprovalLikelihoodBand
} from "api/approval-likelihood";
import { cx } from "shared/utils/classnames";

const BAND_VARIANT: Record<ApprovalLikelihoodBand, BadgeVariant> = {
  low: BadgeVariant.ERROR,
  medium: BadgeVariant.WARNING,
  high: BadgeVariant.SUCCESS
};

interface ApprovalLikelihoodBadgeProps {
  band: ApprovalLikelihoodBand | null | undefined;
  insufficientData?: boolean;
  size?: BadgeSize;
  className?: string;
}

export const ApprovalLikelihoodBadge: FC<ApprovalLikelihoodBadgeProps> = ({
  band,
  insufficientData = false,
  size = BadgeSize.SM,
  className
}) => {
  if (!band) {
    if (!insufficientData) return null;
    return (
      <Badge variant={BadgeVariant.BASE} size={size} className={className}>
        Insufficient data
      </Badge>
    );
  }

  return (
    <Badge
      variant={BAND_VARIANT[band]}
      size={size}
      className={cx(
        "items-center",
        band === "high" ? "text-danger-600" : "",
        className
      )}
      leftElement={
        <Show if={band === "high"}>
          <HugeiconsIcon icon={Fire02Icon} size={12} />
        </Show>
      }
    >
      {APPROVAL_LIKELIHOOD_BAND_LABEL[band]}
    </Badge>
  );
};
